// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2cS6O"};